<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user.js';
    import { _ } from "svelte-i18n";
    import { onMount , onDestroy } from 'svelte';
    import Header from '../components/Header.svelte';
    import Preloader from '../components/Preloader.svelte'; 
    

    let isLoading = false; 

    let formData = {
      client_url: '',
      email: '',
      password: '',
      firstname: '',
      lastname: '',
      phone: '',
      city: '',
      company: '',
      contract: '',
      street: '',
      house:'',
      platform_id : 62,
      action : 'post_reg',
      postil : 1,
      manager : 1,
      user_id : $UserStore.id,
      token : $UserStore.data,
    };
  
    const handleSubmit = async (event) => {
      event.preventDefault();

      isLoading = true;
      const data = await fetchData(formData);
      isLoading = false;
      if (data.success==1) {
        
        push('/my_customers/' + $UserStore.id)

      } else {

        alert('תקלה יש לבדוק שהכל פרטים תקינים ולנסות שוב');

      }

    };
  </script>


<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">
  
        <div class="container mx-auto px-4 py-8 m-auto max-w-[400px]">
            <h1 class="text-2xl font-bold mb-6">{$_('customer.title')}</h1>
        
            <form on:submit|preventDefault={handleSubmit} class="space-y-4">
            <!-- Email -->
            <div>
                <label for="email_text" class="block text-sm font-medium">{$_('customer.email')}</label>
                <input
                type="email"
                id="email_text"
                class="w-full mt-1 p-2 border border-gray-300 rounded"
                bind:value={formData.email}
                required
                />
            </div>
        
            <!-- Password -->
            <div>
                <label for="password_text" class="block text-sm font-medium">{$_('customer.password')}</label>
                <input
                type="text"
                id="password_text"
                class="w-full mt-1 p-2 border border-gray-300 rounded"
                bind:value={formData.password}
                required
                />
            </div>
        
            <!-- First Name -->
            <div>
                <label for="firstname" class="block text-sm font-medium">{$_('customer.firstname')}</label>
                <input
                type="text"
                id="firstname"
                class="w-full mt-1 p-2 border border-gray-300 rounded"
                bind:value={formData.firstname}
                required
                />
            </div>
        
            <!-- Last Name -->
            <div>
                <label for="lastname" class="block text-sm font-medium">{$_('customer.lastname')}</label>
                <input
                type="text"
                id="lastname"
                class="w-full mt-1 p-2 border border-gray-300 rounded"
                bind:value={formData.lastname}
                required
                />
            </div>
        
            <!-- Phone -->
            <div>
                <label for="phone" class="block text-sm font-medium">{$_('customer.phone')}</label>
                <input
                type="tel"
                id="phone"
                class="w-full mt-1 p-2 border border-gray-300 rounded"
                bind:value={formData.phone}
                />
            </div>
        
            <!-- Company -->
            <div>
                <label for="company" class="block text-sm font-medium">{$_('customer.company')}</label>
                <input
                type="text"
                id="company"
                class="w-full mt-1 p-2 border border-gray-300 rounded"
                bind:value={formData.company}
                />
            </div>
        
            <!-- Contract Number -->
            <div>
                <label for="contract" class="block text-sm font-medium">{$_('customer.contract_number')}</label>
                <input
                type="text"
                id="contract"
                class="w-full mt-1 p-2 border border-gray-300 rounded"
                bind:value={formData.contract}
                />
            </div>
        
            <div>
                <label for="city" class="block text-sm font-medium">{$_('customer.city')}</label>
                <input
                type="text"
                id="city"
                class="w-full mt-1 p-2 border border-gray-300 rounded"
                bind:value={formData.city}
                />
            </div>

            <div>
                <label for="street" class="block text-sm font-medium">{$_('customer.street')}</label>
                <input
                type="text"
                id="street"
                class="w-full mt-1 p-2 border border-gray-300 rounded"
                bind:value={formData.street}
                />
            </div>

            <div>
                <label for="house" class="block text-sm font-medium">{$_('customer.house')}</label>
                <input
                type="text"
                id="house"
                class="w-full mt-1 p-2 border border-gray-300 rounded"
                bind:value={formData.house}
                />
            </div>

            <div>
                <label for="url" class="block text-sm font-medium">{$_('customer.url')}</label>
                <input
                type="text"
                id="url"
                class="w-full mt-1 p-2 border border-gray-300 rounded"
                bind:value={formData.client_url}
                />
            </div>
        
            <!-- Submit Button -->
            <div>
                <button
                type="submit"
                class="create_button m-0 w-full text-center justify-center"
                >
                {$_('customer.create')}
                </button>
            </div>
            </form>
        </div>
    </div>
</div>
  